import { API_URL } from 'config';
import { makeAPICall } from 'models/api';

export declare namespace API {
    export interface Role {
        id: number;
        name: string;
    }

    export interface RoleList {
        roles: Role[];
        total: number;
    }

    interface APIModelRoot {
        data: Role[];
        count: number;
    }

    export interface ActionResponse {
        results: 'success' | 'error';
        error?: string;
    }
}

export interface Role {
    roleId: number;
    roleName: string;
}
export const mapAPIToRole = ({ id, name, ...rest }: API.Role): Role => ({
    ...rest,
    roleId: id,
    roleName: name,
});

export const getRoles = makeAPICall<Role[], void, API.Role[]>(
    () => ({
        url: `${API_URL}/roles/`,
    }),
    (raw) => raw.map(mapAPIToRole),
);
